import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import PropTypes from "prop-types";
import FollowingInsert from "./FollowingInsert";


class   MemberFollow   extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.props=props;
    }


    render() {

        return (<>
            <div className="network-item-footer py-3 d-flex text-center">
                <div className="col-12 px-3  "> <FollowingInsert memberId={this.props.memberId} /></div>
            </div></>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

MemberFollow.contextType = MCbrowser;

MemberFollow.propTypes = {
    memberId:PropTypes.string,
};


export default MemberFollow;
